'use strict';

var util = require('./util');

var traverse = require('traverse');

exports = module.exports;
exports.multicodec = 'dag-cbor';
exports.defaultHashAlg = 'sha2-256';
/*
 * resolve: receives a path and a binary blob and returns the value on path,
 * throw if not possible. `binaryBlob` is CBOR encoded data.
 */

exports.resolve = function (binaryBlob, path, callback) {
  if (typeof path === 'function') {
    callback = path;
    path = undefined;
  }

  util.deserialize(binaryBlob, function (err, node) {
    if (err) {
      return callback(err);
    } // root


    if (!path || path === '/') {
      return callback(null, {
        value: node,
        remainderPath: ''
      });
    } // within scope


    var parts = path.split('/');
    var val = traverse(node).get(parts);

    if (val) {
      return callback(null, {
        value: val,
        remainderPath: ''
      });
    } // out of scope


    var value;
    var len = parts.length;

    for (var i = 0; i < len; i++) {
      var partialPath = parts.shift();

      if (Array.isArray(node) && !Buffer.isBuffer(node)) {
        value = node[Number(partialPath)];
      }

      if (node[partialPath]) {
        value = node[partialPath];
      } else {
        // can't traverse more
        if (!value) {
          return callback(new Error('path not available at root'));
        } else {
          parts.unshift(partialPath);
          return callback(null, {
            value: value,
            remainderPath: parts.join('/')
          });
        }
      }

      node = value;
    }
  });
};

function flattenObject(obj, delimiter) {
  delimiter = delimiter || '/';

  if (Object.keys(obj).length === 0) {
    return [];
  }

  return traverse(obj).reduce(function (acc, x) {
    if (typeof x === 'object' && x['/']) {
      this.update(undefined);
    }

    var path = this.path.join(delimiter);

    if (path !== '') {
      acc.push({
        path: path,
        value: x
      });
    }

    return acc;
  }, []);
}
/*
 * tree: returns a flattened array with paths: values of the project. options
 * are option (i.e. nestness)
 */


exports.tree = function (binaryBlob, options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = undefined;
  }

  options = options || {};
  util.deserialize(binaryBlob, function (err, node) {
    if (err) {
      return callback(err);
    }

    var flat = flattenObject(node);
    var paths = flat.map(function (el) {
      return el.path;
    });
    callback(null, paths);
  });
};

exports.isLink = function (binaryBlob, path, callback) {
  exports.resolve(binaryBlob, path, function (err, result) {
    if (err) {
      return callback(err);
    }

    if (result.remainderPath.length > 0) {
      return callback(new Error('path out of scope'));
    }

    if (typeof result.value === 'object' && result.value['/']) {
      callback(null, result.value);
    } else {
      callback(null, false);
    }
  });
};